import ToggleSwitch from "../ToggleSwitch";
import type { FormFieldOption, HandleInputChange } from "./types";

type ToggleSwitchInputProps = {
    name: string;
    options?: Array<FormFieldOption | string>;
    value?: string;
    onChange: HandleInputChange;
};

const ToggleSwitchInput = ({ name, options = [], value, onChange }: ToggleSwitchInputProps) => {
    const normalizedOptions = Array.isArray(options)
        ? options.map((option) => {
            if (typeof option === "string") return {label: option, value: option};
            return option;
        })
        : [];
    const defaultValue = value || normalizedOptions[0].value;

    return (
        <ToggleSwitch
            value={defaultValue}
            options={normalizedOptions}
            onChange={(selectedValue: string) => onChange(null, name, selectedValue)}
        />
    );
};

export default ToggleSwitchInput;
